var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('shifts-counter-view-single',{attrs:{"isManagementEvaluation":_vm.isManagementEvaluation,"value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }